import type { AgentTemplate } from "../mock";
import { CustomCtaTile } from "../../../components/dashboard/agent-templates/CustomCtaTile";
import { TemplateCard } from "../../../components/dashboard/agent-templates/TemplateCard";
import styles from "./AgentTemplates.module.css";

type Props = {
  templates: AgentTemplate[];
};

export const AgentTemplatesSection = ({ templates }: Props): JSX.Element => (
  <section className={styles.section} aria-labelledby="dashboard-templates-title">
    <header className={styles.header}>
      <div className={styles.headerLeft}>
        <span className={styles.eyebrow}>// AGENTS · PREVIEW</span>
        <h2 className={styles.headline} id="dashboard-templates-title">
          Agents, ready to go.
        </h2>
      </div>
    </header>
    <div className={styles.grid}>
      <CustomCtaTile />
      {templates.map((template) => (
        <TemplateCard key={template.slug} template={template} />
      ))}
    </div>
  </section>
);
